import Vue from 'vue'
import * as types from '../mutation-types'

const state = {
  physicsB: false,
  siteHeader: 'small',
  exhibitPill: 'small'
}

const getters = {
  getPhysicsB: state => state.physicsB,
  getSiteHeader: state => state.siteHeader,
  getExhibitPill: state => state.exhibitPill
}

const actions = {}

const mutations = {
  [types.UPDATE_PHYSICS] (state, { field, value }) {
    Vue.set(state, field, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
